import React from 'react';
import { motion } from 'framer-motion';
interface MaterialFieldProps {
  accent: string;
}
const blobs = [{
  size: 46,
  x: ['-12vw', '6vw', '-12vw'],
  y: ['-8vh', '10vh', '-8vh'],
  duration: 26,
  opacity: 0.3
}, {
  size: 34,
  x: ['62vw', '48vw', '62vw'],
  y: ['22vh', '38vh', '22vh'],
  duration: 32,
  opacity: 0.22
}, {
  size: 28,
  x: ['24vw', '34vw', '24vw'],
  y: ['64vh', '48vh', '64vh'],
  duration: 22,
  opacity: 0.16
}];

/**
 * The living background of the experience: suspended translucent material,
 * slow stratification lines and fine grain. Colour follows the visitor's
 * current clinical focus so the whole surface shifts with their choices.
 */
export function MaterialField({
  accent
}: MaterialFieldProps) {
  return <div className="grain pointer-events-none fixed inset-0 -z-10 overflow-hidden bg-ink" aria-hidden="true" data-id="element-2" data-mp="2aukdm365gpws">
      {blobs.map((blob, index) => <motion.div key={index} className="absolute left-0 top-0 rounded-full blur-[110px]" style={{
      width: `${blob.size}vw`,
      height: `${blob.size}vw`,
      minWidth: 280,
      minHeight: 280
    }} animate={{
      x: blob.x,
      y: blob.y,
      backgroundColor: accent,
      opacity: blob.opacity
    }} transition={{
      x: {
        duration: blob.duration,
        repeat: Infinity,
        ease: 'easeInOut'
      },
      y: {
        duration: blob.duration * 1.15,
        repeat: Infinity,
        ease: 'easeInOut'
      },
      backgroundColor: {
        duration: 1.1,
        ease: 'easeInOut'
      },
      opacity: {
        duration: 1.1
      }
    }} data-id="element-3" data-mp="25x0xsytt052q" data-mpi={index} />)}

      {/* Stratification — enamel layers read as horizontal strata */}
      <div className="absolute inset-0" data-id="element-4" data-mp="1cflmg5njyey8">
        {[14, 30, 46, 62, 78, 92].map((top, index) => <motion.div key={top} className="absolute left-0 h-px w-full" style={{
        top: `${top}%`,
        backgroundColor: 'rgba(244,242,237,0.07)'
      }} animate={{
        scaleX: [0.9, 1, 0.9],
        opacity: [0.5, 1, 0.5]
      }} transition={{
        duration: 18 + index * 2,
        repeat: Infinity,
        ease: 'easeInOut',
        delay: index * 0.6
      }} data-id="element-5" data-mp="1he6s4klkpqu2" data-mpi={index} />)}
      </div>

      <div className="absolute inset-0" style={{
      boxShadow: 'inset 0 0 220px 80px rgba(1,51,43,0.92)'
    }} data-id="element-6" data-mp="35a3fhevpafdw" />
    </div>;
}